<template>
  <div class="overlay-container">

    <!-- LOADING ANIMATION -->
    <div
      v-if="!loggingOut"
      class="lds-ripple"
      :class="{ 'hide-ripple': initialDataLoaded || $route.name === 'NoInternet' }">
      <div></div>
      <div></div>
      <div></div>
    </div>

    <div
      class="loading" />

    <div class="overlay-content">
      <div class="logo">
        Byblio
      </div>
      {{ loggingOut || $route.name === 'NoInternet' ? '' : 'Welcome back!' }}
      <br>
      <div>
        <div
          v-if="loggingOut"
          class="icon">
          <i class="mdi mdi-shield-lock mdi-36px flip" />
        </div>
        <div v-else-if="$route.name==='NoInternet'">
          Failed to connect! Please check your internet connection.
        </div>
        <div
          v-else
          class="progress-text">
          {{ initialDataLoaded ? 'Ready!' : loadingText }}<span class="progress-text-dot" v-show="!initialDataLoaded">.</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ScreenOverlay',
  data() {
    return {
      loadingText: 'Setting up your Byblio..',
    };
  },
  computed: {
    ...mapState({
      initialDataLoaded: state => state.appState.initialDataLoaded,
      loggingOut: state => state.appState.screenOverlayLogout,
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/colors';
@import '~styles/fonts';

.overlay-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: $secondary;
  z-index: 10000;
  box-shadow: 0 6px 6px 4px $primary-dark;
}
.loading {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background: $secondary;
}
.overlay-content {
  position: absolute;
  height: 100vh;
  width: 100vw;
  top: 25vh;
  color: $secondary-dark;
  mix-blend-mode: screen;
  text-align: center;
}
.logo {
  width: 100vw;
  display: flex;
  justify-content: center;
  font-family: $quattrocento;
  font-size: 4rem;
  letter-spacing: 0.5rem;
}
.progress-text {
  padding-top: 10vh;
  font-size: 1.2rem;
}
.progress-text-dot {
  animation: flicker 0.5s cubic-bezier(0, 0.8, 1, 1) infinite alternate;
}
.icon {
  color: $secondary-dark;
  width: fit-content;
}
.flip {
  animation: flip 1s ease-in-out infinite;
}

@keyframes flicker {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes flip {
  0% {
    transform: rotateY(0);
  }
  100% {
    transform: rotateY(-180deg);
  }
}

.lds-ripple {
  display: inline-block;
  position: absolute;
  top: -15vh;
  left: 20vw;
  width: 64vw;
  height: 64vw;
  z-index: 10;
  opacity: 1;
  transition: opacity 0.3s;
}
.hide-ripple {
  opacity: 0;
}
.lds-ripple div {
  position: absolute;
  border: 8px solid $secondary-light;
  opacity: 0.8;
  border-radius: 50%;
  animation: lds-ripple 6s cubic-bezier(0, 0.6, 0.8, 1);
}
.lds-ripple div:nth-child(1) {
  animation-delay: 0s;
  animation: lds-ripple 6s cubic-bezier(0, 0.6, 0.8, 1) alternate;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -2s;
}
.lds-ripple div:nth-child(3) {
  animation-delay: -4s;
}
@keyframes lds-ripple {
  0% {
    top: 30vw;
    left: 30vw;
    width: 0;
    height: 0;
    opacity: 0.8;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 60vw;
    height: 60vw;
    opacity: 0;
  }
}
</style>
